import ExceptionBase from "@/dto/exceptions/exceptionBase";
export default class InvalidParameterValidationException extends ExceptionBase {
  constructor(data) {
    super(data);
  }
}
